import type { BaseUrlFactory } from '@/modules/http-client/domain/base-url/BaseUrlFactory';
import { configProvider } from '@/common/app-config/public/configuration-provider';

export class AppConfigBaseUrlFactory implements BaseUrlFactory {
  make(): string {
    return `https://${configProvider.get().apiUrl}`;
  }
}
